import { render, staticRenderFns } from "./CommunityInfo.vue?vue&type=template&id=9b81a250&scoped=true"
import script from "./CommunityInfo.vue?vue&type=script&lang=js"
export * from "./CommunityInfo.vue?vue&type=script&lang=js"
import style0 from "./CommunityInfo.vue?vue&type=style&index=0&id=9b81a250&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b81a250",
  null
  
)

export default component.exports